import Cookies from 'js-cookie';
import storageAvailable from './storageAvailable';

type StringStorage = {
    getItem(key: string): string | null | undefined;
    setItem(key: string, value: string): void;
    removeItem(key: string): void;
};

// Session cookies (no expiry) stand in for sessionStorage where the browser blocks it.
const cookieStorage: StringStorage = {
    getItem: key => Cookies.get(key),
    setItem: (key, value) => {
        Cookies.set(key, value, { path: '/' });
    },
    removeItem: key => {
        Cookies.remove(key, { path: '/' });
    },
};

let storage: StringStorage | undefined;

// Resolved on first use, so importing this module has no side effects.
function getStorage(): StringStorage {
    if (storage) return storage;

    if (storageAvailable('sessionStorage')) {
        storage = window.sessionStorage;
    } else if (window.navigator.cookieEnabled) {
        storage = cookieStorage;
    } else {
        throw new Error('Cookies are required to use this site');
    }

    return storage;
}

// Per-tab storage that clears when the session ends. The Angular TransientClientStorage factory
// returns this outside of test mode, so both sides read and write the same values.
const TransientClientStorage = {
    getItem: (key: string) => getStorage().getItem(key) ?? undefined,
    setItem: (key: string, value: unknown) => getStorage().setItem(key, String(value)),
    removeItem: (key: string) => getStorage().removeItem(key),
};

export default TransientClientStorage;
